exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-right {\r\n    text-align: right;\r\n}\r\n\r\n.export-container {\r\n    width: 100%;\r\n    margin-top: 15px;\r\n}\r\n\r\n.exported-game {\r\n    word-break: break-all;\r\n    font-family: Courier New, Courier, monospace;\r\n    background-color: #F0F0F0;\r\n    padding: 15px;\r\n    max-height: 240px;\r\n    overflow-y: auto;\r\n    resize: none;\r\n    width: calc(100% - 30px);\r\n}\r\n\r\n.copy-success {\r\n    background-color: #1B5E20;\r\n    color: #FAFAFA;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/export-game-dialog/export-game-dialog.component.css
// module id = ../../../../../src/app/generator/export-game-dialog/export-game-dialog.component.css
// module chunks = main